import { render, staticRenderFns } from "./ButtonJobs.vue?vue&type=template&id=40da032e&scoped=true"
import script from "./ButtonJobs.js?vue&type=script&lang=js&external"
export * from "./ButtonJobs.js?vue&type=script&lang=js&external"
import style0 from "./ButtonJobs.scss?vue&type=style&index=0&id=40da032e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da032e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Icon/Icon.vue').default})
